/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_IbanInputs */

const de__field_iban = /** @type {(inputs: _Field_IbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IBAN`)
};

/**

* @param {_Field_IbanInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_iban = /** @type {((inputs?: _Field_IbanInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_IbanInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_iban(inputs)
});